import React from 'react'
import styled from 'styled-components'
import {
  header2BlackStyle,
  headerBlackStyle,
  magicContainer2Style,
  text2GrayStyle,
} from '../styled'
import CaretIcon from 'images/caret.svg'
import mediaQuery from 'styles/mediaQuery'
import { MAX_CHARACTERS } from './consts'

const Section = styled.section`
  position: relative;
  width: 100%;
  padding: 32px 0 44px;
  background-color: #fbfbfe;
  ${mediaQuery.desktopMin} {
    padding: 72px 0 88px;
  }
`

const Container = styled.div`
  ${magicContainer2Style};
`

const TitlesWrapper = styled.div`
  width: 100%;
`

const Title = styled.h2`
  ${headerBlackStyle};
  text-align: center;
`

const FaqContainer = styled.section`
  margin-top: 48px;
`

const FaqItem = styled.div`
  padding: 16px;
  &:not(:last-child) {
    border-bottom: 1px solid rgba(217, 217, 217, 1);
  }
  &.active {
    & > p {
      -webkit-line-clamp: unset;
    }
    svg {
      transform: rotate(180deg);
    }
  }
`

const FaqItemHeader = styled.header`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  & > h4 {
    ${header2BlackStyle};
  }
  & > svg {
    width: 24px;
    margin-left: auto;
    transition: 0.5s;
  }
`

const FaqItemDescription = styled.p`
  ${text2GrayStyle};
  margin-top: 11px;
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const HomeFaq = ({ faqData, refFaq, lines, translations, toggleDetails }) => (
  <Section id="faq">
    <Container>
      <TitlesWrapper>
        <Title>{translations.header}</Title>
      </TitlesWrapper>
      <FaqContainer ref={refFaq}>
        {faqData.map(({ question, answer, classes }, index) => (
          <FaqItem key={question} className={classes}>
            <FaqItemHeader onClick={() => toggleDetails(index)}>
              <h4>{question}</h4>
              {answer.length > MAX_CHARACTERS && <CaretIcon />}
            </FaqItemHeader>
            <FaqItemDescription lines={lines}>{answer}</FaqItemDescription>
          </FaqItem>
        ))}
      </FaqContainer>
    </Container>
  </Section>
)

export default HomeFaq
